import React, { useCallback, useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import cn from 'classnames';
import Link from '../link';
import Heading from '../heading';
import Button from '../button';
import CloseIcon from '../../../icons/close-icon.inline.svg';
import shape from '../popup-banner/images/shape.svg';
import dots from '../popup-banner/images/dots-pattren.svg';
import styles from './styles.module.scss';

const KEY_LOCAL_STORAGE = 'hide-prompt-banner';
const getLocalStorage = () => JSON.parse(localStorage.getItem(KEY_LOCAL_STORAGE));

const setLocalStorage = () => {
  localStorage.setItem(KEY_LOCAL_STORAGE, 'true');
};

const GlobalPopupBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { wpSharedBlock } = useStaticQuery(
    graphql`
      query {
        wpSharedBlock(slug: { eq: "prompt-banner" }) {
          acf {
            show
            btnlink
            btnlabel
            desc
            title
          }
        }
      }
    `
  );

  const { acf } = wpSharedBlock || {};
  const { btnlink, btnlabel, desc, title, show } = acf || {};

  const handleButtonClose = useCallback(() => {
    setIsOpen(false);
    setLocalStorage();
  }, []);

  const handleOpen = useCallback(() => {
    const { outerHeight: heightPage, scrollY } = window || {};
    // calc: show window when the page is scrolled more than 30%
    const scrollPercentage = (heightPage / 100) * 30;

    if (scrollY >= scrollPercentage && !getLocalStorage()) {
      return setIsOpen(true);
    }
    return setIsOpen(false);
  }, [getLocalStorage]);

  useEffect(() => {
    // if there is no data on this pdf resource in the local storage, then open
    if (!getLocalStorage()) {
      window.addEventListener('scroll', handleOpen);

      return () => {
        window.removeEventListener('scroll', handleOpen);
      };
    }
    return null;
  }, [handleOpen]);

  if (!show) {
    return null;
  }

  return (
    <div className={cn(styles.wrapper, { [styles.isOpen]: isOpen })}>
      <div className={styles.content}>
        <Link className={styles.titleWrapper} to={btnlink}>
          <Heading className={styles.title} size="md" tag="h5">
            {title}
          </Heading>
        </Link>
        {desc && <p className={styles.description}>{desc}</p>}
      </div>
      <Button className={styles.button} to={btnlink} size="sm" theme="accent-primary">
        {btnlabel}
      </Button>

      <button className={styles.close} type="button" onClick={handleButtonClose}>
        <CloseIcon />
      </button>

      <img className={styles.shape} src={shape} alt="" loading="lazy" aria-hidden />
      <img className={styles.dots} src={dots} alt="" loading="lazy" aria-hidden />
    </div>
  );
};

export default GlobalPopupBanner;
